import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { default as BudgetListContainer } from './BudgetListContainer';
import { default as BudgetCardPreviewContainer } from './BudgetCardPreviewContainer';
import { default as BudgetCardVoteContainer } from './BudgetCardVoteContainer';
import { RouteUrls } from '../../../configs/routeUrls';
import { default as ProjectTaskListContainer } from './ProjectTasks/ProjectTaskListContainer';
import { default as ProjectTaskCardContainer } from './ProjectTasks/ProjectTaskCardContainer';
import { default as BudgetPageContainer } from './BudgetPageContainer';
import { default as BudgetResultContainer } from './BudgetResultContainer';
import { BudgetPageType } from '../../../utils/enums';

export class Budget extends Component {
	render() {
		return (
			<div>
				<div>{this.props.children}</div>
				<Route exact path={RouteUrls.Budget.list.actual} component={BudgetListContainer} />
				<Route exact path={RouteUrls.Budget.list.finished} component={BudgetListContainer} />
				<Route path={RouteUrls.Budget.vote.preview} component={BudgetCardPreviewContainer} />
				<Route path={RouteUrls.Budget.vote.vote} component={BudgetCardVoteContainer} />
				<Route path={RouteUrls.Budget.projectTasks.list} component={ProjectTaskListContainer} />
				<Route path={RouteUrls.Budget.projectTasks.map} component={ProjectTaskListContainer} />
				<Route path={`${RouteUrls.Budget.projectTasks.preview}/:id`} component={ProjectTaskCardContainer} />
				<Route
					path={RouteUrls.Budget.pages.help}
					render={(props) => <BudgetPageContainer {...props} type={BudgetPageType.Help} />}
				/>
				<Route
					path={RouteUrls.Budget.pages.prerequisite}
					render={(props) => <BudgetPageContainer {...props} type={BudgetPageType.Prerequisite} />}
				/>
				<Route
					path={RouteUrls.Budget.pages.schedule}
					render={(props) => <BudgetPageContainer {...props} type={BudgetPageType.Schedule} />}
				/>
				<Route path={RouteUrls.Budget.vote.result} component={BudgetResultContainer} />
			</div>
		);
	}
}
